import * as types from './mutation-types'

export default {
  [types.SET_EMAIL_USUARIO] (state, emailUsuario) {
    state.emailUsuario = emailUsuario
  },
  [types.SET_NOME_EMPRESA] (state, nomeEmpresa) {
    state.nomeEmpresa = nomeEmpresa
  },
  [types.SET_ID_EMPRESA] (state, idEmpresa) {
    state.idEmpresa = idEmpresa
  },
  [types.SET_CPF_CNPJ] (state, cpfCnpj) {
    state.cpfCnpj = cpfCnpj
  },
  [types.SET_REPRESENTANTE_LEGAL] (state, representanteLegal) {
    state.representanteLegal = representanteLegal
  },
  [types.SET_REGRAS_LOGIN] (state, regrasLogin) {
    state.regrasLogin = regrasLogin
  },
  [types.SET_LOGIN_STRATEGY] (state, loginStrategy) {
    state.loginStrategy = loginStrategy
  },
  [types.SET_LOGO_CLIENTE] (state, logoCliente) {
    state.logoCliente = logoCliente
  },
  [types.SET_ESCRITORIO] (state, escritorio) {
    state.escritorio = escritorio
  },
  [types.SET_TIPO_DE_ACESSO] (state, tipoDeAcesso) {
    state.tipoDeAcesso = tipoDeAcesso
  },
  [types.SET_ACESSO_FINANCEIRO] (state, temAcessoAoFinanceiro) {
    state.temAcessoAoFinanceiro = temAcessoAoFinanceiro
  },
  [types.SET_ACESSO_RELATORIOS] (state, temAcessoAosRelatorios) {
    state.temAcessoAosRelatorios = temAcessoAosRelatorios
  },
  [types.SET_ACESSO_RELATORIOS_CONTRATADO] (state, relatoriosContratado) {
    state.relatoriosContratado = relatoriosContratado
  },
  [types.SET_ACESSO_ESCRITORIO] (state, temAcessoAoEscritorio) {
    state.temAcessoAoEscritorio = temAcessoAoEscritorio
  },
  [types.SET_FINANCEIRO_CONTRATADO] (state, financeiroContratado) {
    state.financeiroContratado = financeiroContratado
  },
  [types.SET_ACESSO_FATURAMENTO] (state, temAcessoAoFaturamento) {
    state.temAcessoAoFaturamento = temAcessoAoFaturamento
  },
  [types.SET_FATURAMENTO_CONTRATADO] (state, faturamentoContratado) {
    state.faturamentoContratado = faturamentoContratado
  },
  [types.SET_NOME_USUARIO_LOGADO] (state, nomeUsuarioLogado) {
    state.nomeUsuarioLogado = nomeUsuarioLogado
  },
  [types.SET_CODIGO_FOTO_USUARIO] (state, codigoFotoUsuario) {
    state.codigoFotoUsuario = codigoFotoUsuario
  },
  [types.SET_PERFIL_USUARIO] (state, perfilUsuario) {
    state.perfilUsuario = perfilUsuario
  },
  [types.SET_ESCRITORIO_INADIMPLENTE] (state, escritorioInadimplente) {
    state.escritorioInadimplente = escritorioInadimplente
  },
  [types.SET_DADOS_ALERTA_VENCIMENTO] (state, dadosAlertaVencimento) {
    state.dadosAlertaVencimento = dadosAlertaVencimento
  },
  [types.SET_DADOS_ALERTA_DESBLOQUEIO_ESCRITORIO] (state, dadosAlertaDesbloqueio) {
    state.dadosAlertaDesbloqueio = dadosAlertaDesbloqueio
  },
  [types.SET_ID_USUARIO_LOGADO] (state, idUsuarioLogado) {
    state.idUsuarioLogado = idUsuarioLogado
  },
  [types.SET_DATA_CRIACAO_USUARIO_LOGADO] (state, dataCriacaoUsuarioLogado) {
    state.dataCriacaoUsuarioLogado = dataCriacaoUsuarioLogado
  },
  [types.SET_SUPORTE_ONLINE_HABILITADO] (state, suporteOnlineHabilitado) {
    state.suporteOnlineHabilitado = suporteOnlineHabilitado
  },
  [types.SET_DADOS_CAMPANHA_MARKETING] (state, dadosCampanhaMarketing) {
    state.dadosCampanhaMarketing = dadosCampanhaMarketing
  },
  [types.SET_OCULTAR_OPCAO_MENU_BANCO] (state, ocultarOpcaoMenuBanco) {
    state.ocultarOpcaoMenuBanco = ocultarOpcaoMenuBanco
  },
  [types.SET_ALERTA_STATUS_EMPRESA] (state, alertaStatusEmpresa) {
    state.alertaStatusEmpresa = alertaStatusEmpresa
  }
}
